import type { AddressSearchProvider } from 'api/models/mainservice';
import { BasicAddressInput } from 'components/forms/hook-form';
import AddressAutoCompleteInput from 'components/forms/hook-form/address/AddressAutoCompleteInput';
import { oneLineAddress, useAddressFormOperations } from 'helpers/addressHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import { useValidators } from 'helpers/validation';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

interface PublicOrderRequestFormAddressHandlerProps {
  addressSearchProvider: AddressSearchProvider;
}

const PublicOrderRequestFormAddressHandler = ({
  addressSearchProvider
}: PublicOrderRequestFormAddressHandlerProps) => {
  const {
    loadAddresses,
    handleSelect,
    isSearchingAddressAutoCompleteItems,
    itemsForAutocomplete,
    addressSelectedSuccessfully,
    cleanInputsValues
  } = useAddressFormOperations();

  const { watch, setValue, trigger, getFieldState } = useFormContext();

  const { tInput, tError } = useCustomTranslation();
  const validators = useValidators();

  const [showAllFields, setShowAllFields] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getFieldState('fakeStreet').isDirty && trigger('fakeStreet');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressSelectedSuccessfully]);

  const handleShowAllFields = () => {
    setShowAllFields(true);
    cleanInputsValues();
    // setValue('street', watch('fakeStreet'));
    setValue('fakeStreet', undefined);
  };

  if (!showAllFields) {
    return (
      <AddressAutoCompleteInput
        name="fakeStreet"
        required
        options={{
          required: validators.required,
          maxLength: validators.maxLength(100),
          validate: (value) =>
            !addressSelectedSuccessfully ||
            oneLineAddress({
              city: watch('city'),
              postalCode: watch('postalCode'),
              street: watch('street')
            }) !== value
              ? tError('address_not_picked')
              : undefined
        }}
        items={itemsForAutocomplete}
        label={tInput('address_input')}
        placeholder={tInput('address_placeholder')}
        handleSelect={(id, provider) => handleSelect(id, provider, true, true, handleShowAllFields)}
        loadAddresses={(phrase, provider) => loadAddresses(phrase, provider, true)}
        defaultSearchProvider={addressSearchProvider}
        isSearching={isSearchingAddressAutoCompleteItems}
        handleSwitchToAllFields={() => setShowAllFields(true)}
      />
    );
  }

  return <BasicAddressInput required defaultSearchProvider={addressSearchProvider} isPublic />;
};

export default PublicOrderRequestFormAddressHandler;
